module.exports = __webpack_public_path__ + "static/media/form_image.ef5b6f7d.png";